export const parseContentDisposition = (header: string) => {
  if (!header) return null;
  const params = header.split(';').map((p) => p.trim());
  const type = params[0].toLowerCase();
  const filenameMatch = params.find((p) => p.startsWith('filename'));
  const filenameStarMatch = params.find((p) => p.startsWith('filename*'));

  let filename = '';

  if (filenameStarMatch) {
    const [, encoded] = filenameStarMatch.split('=');
    filename = decodeURIComponent(encoded.replace(/^utf-8''/i, ''));
  } else if (filenameMatch) {
    filename = filenameMatch.split('=')[1].replace(/["']/g, '');
  }

  return { type, filename };
};
